import { Chip } from "@mui/material";

type NewBadgeProps = {
  label?: string;
};

export const NewBadge = ({ label = "NEW" }: NewBadgeProps) => (
  <Chip
    label={label}
    size="small"
    sx={{
      position: "absolute",
      top: -10,
      right: 14,
      zIndex: 1,
      height: 20,
      borderRadius: "999px",
      bgcolor: "#3b82f6",
      color: "#fff",
      fontSize: "0.62rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
      animation: "newBadgeVibrate 4s ease-in-out 3",
      "@keyframes newBadgeVibrate": {
        "0%, 20%, 100%": { transform: "translateX(0) rotate(0deg)" },
        "4%, 12%": { transform: "translateX(-2px) rotate(-2deg)" },
        "8%, 16%": { transform: "translateX(2px) rotate(2deg)" },
      },
      "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
      },
      "& .MuiChip-label": { px: 1 },
    }}
  />
);
